import { Component, Vue, Watch } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import Task from '@/web-task'
import TaskApi from '@/api/task'
import EvaluateApi from '@/api/evaluate'
import { wsURL } from '@/api/url'
import watermark from '@/utils/watermark'
import {
	uuid,
	dateFormat,
	throttle,
	download,
	triggerWindowResizeEvent,
} from '@/utils/util'
import moment from 'moment'
import {
	initOrderDetail,
	initHomeInvestigateDetail,
} from '@/web-task/utils/order'
const authMap = {
	mediateInfo: {
		title: '调解信息',
		authStr: 'taskDetail:mediateInfo',
		// key值在Tabs.vue中也有用到，改动需要同时修改Tabs.vue
		key: '0',
	},
	basicInfo: {
		title: '基本信息',
		authStr: 'taskDetail:basicInfo',
		key: '1',
	},
	imageInfo: {
		title: '影像信息',
		authStr: 'taskDetail:imageInfo',
		key: '2',
	},
	relationOrders: {
		title: '关联订单',
		authStr: 'taskDetail:relationOrders',
		key: '3',
	},
	pendingTrack: {
		title: '未决跟踪情况',
		authStr: 'taskDetail:pendingTrack',
		key: '4',
	},
}

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({})
export default class TaskDetailMixins extends Vue {
	// 详情页mixins
	public order: any = ''
	public injured: any = ''
	public boardImageList: any = ''
	public task: any = ''
	public riskList: any = []
	public tabs: any = {
		index: authMap.basicInfo.key,
		items: [
			// items初始项 避免详情页计算margin时缺少tabs高度
			authMap.basicInfo,
		],
		active: () => {
			return this.tabs.index
		},
		callback: (key: any) => {
			this.tabs.index = key
		},
	}

	public ws: any = ''
	public timer: any = ''
	public expireTimer: any = ''
	public throttleOpenWS = throttle(10 * 1000)

	private init() {
		this.order = ''
		this.injured = ''
		this.boardImageList = ''
		this.riskList = []
		// this.tabs.index = '1'
		this.ws && this.ws.close()
		this.getDetail().then(() => {
			this.openWS()
			this.drawWatermark()
		})
	}

	private activated() {
		this.init()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.$nextTick(() => {
			this.init()
		})
		next()
	}

	private beforeRouteLeave(to: any, from: any, next: any) {
		this.removeWatermark()
		next()
	}

	@Watch('order')
	private onOrderChange() {
		// 状态变化后获取详情则设置tabs
		this.task = new Task({
			propsData: {
				order: this.order,
				injured: this.injured,
				boardImageList: this.boardImageList,
				setting: this.$store.state.setting,
			},
		})

		this.setNavTabs(this.task)
	}

	public deactivated() {
		// this.tabs.index = '1'
		this.ws && this.ws.close()
		this.removeWatermark()
	}

	public drawWatermark() {
	    let txt = this.$route.params.watermark || ''
		if (txt) {
			watermark.init({
				watermark_txt: `${txt}`,
				watermark_width: 200,
				watermark_x: 0,
				watermark_y: 0,
				watermark_x_space: 50,
				watermark_y_space: 50,
				watermark_alpha: 0.05,
				watermark_fontsize: '30px',
				watermark_angle: 35,
			})
		}
	}

	private removeWatermark() {
		try {
			watermark.remove()
		} catch (err) {
			// 忽略报错
		}
	}

	public openWS() {
		if (!this.order.orderNo) {
			return
		}
		TaskApi.getMsgToken(this.order.orderNo).then((res: any) => {
			if (res.code !== 200) {
				return
			}
			const msgToken = res.data
			const ws = new WebSocket(wsURL)
			this.ws = ws
			ws.onmessage = (event: any) => {
				try {
					const data: any = JSON.parse(event.data)
					if (data.content) {
						const content: any = JSON.parse(JSON.parse(data.content))
						if (content.status && content.status !== this.order.orderStatus) {
							this.getDetail()
						}
					}
				} catch (e) {
					//
				}
			}
			ws.onopen = () => {
				ws.send(
					JSON.stringify({
						requestId: uuid(),
						requestTime: moment().format('YYYY-MM-DD HH:mm:ss'),
						version: 'V1.0',
						data: {
							msgToken,
						},
					})
				)
				this.timer = setInterval(() => {
					ws.send('ping')
				}, 9 * 1000)
				this.expireTimer = setTimeout(() => {
					TaskApi.expireToken(this.order.orderNo)
				}, 29 * 60 * 1000)
			}
			ws.onclose = () => {
				clearTimeout(this.timer)
				clearTimeout(this.expireTimer)
				if (
					['investigate/taskDetail', 'AiiTaskDetail'].includes(
						this.$route.name as any
					) &&
					this.order.orderStatus
				) {
					this.throttleOpenWS(this.openWS)
				}
			}
		})
	}

	public getDetail() {
		let desensitize = this.$route.params.desensitize === '1'
		let key = this.$route.params.key || ''

		const apiCall = key
			? TaskApi.getOpenDetail(this.$route.params.orderId, key)
			: TaskApi.getTaskDetail(this.$route.params.orderId, desensitize, key)

		return apiCall.then(
			(data: any) => {
				if (data.code === 200) {
					this.order = data.data.order
					const task = new Task({
						propsData: {
							order: this.order,
						},
					})
					this.injured = initOrderDetail(data.data)
					this.boardImageList = data.data.boardImageList
					if ('riskList' in data.data) {
						this.riskList = data.data.riskList
					}
				} else if (key) {
					// 外部链接页获取详情失败 → 跳转错误页
					const errorMsg = data.message || '服务器异常'
					this.$router.replace({
						path: '/error-page',
						query: { error: errorMsg },
					})
				} else if (data.code === 503 && data.message === '权限不足，操作非法') {
					this.$store.dispatch('user/Logout').then(() => {
						window.location.replace(`${location.origin}/passport/login`)
					})
				} else {
					this.$notification.error({
						message: '错误',
						description: data.message,
					})
				}
			}
		).catch((err: any) => {
			if (key) {
				// 外部链接页：拦截器已 reject → 跳转错误页
				const errorMsg = (err && err.message) || '服务器异常'
				this.$router.replace({
					path: '/error-page',
					query: { error: errorMsg },
				})
			}
		})
	}

	private setCurrentTab(itemList: any) {
		// 设置有权限的items项 同时根据items项设置index项
		let items = cloneDeep(itemList)
		items = items.filter((item: any) => this.$auth(item.authStr))

		const active = this.$route.query && this.$route.query.active
		const keyArr = items.map((item: any) => item.key)

		this.tabs.items = items
		if (active && keyArr.includes(active)) {
			this.tabs.index = active
		} else {
			this.tabs.index = items[0] && items[0].key
		}
	}

	public setNavTabs(task: any) {
		let items: any = [
			authMap.basicInfo,
			authMap.imageInfo,
			authMap.relationOrders,
		]
		if (task.isOtherMediate) {
			items = [authMap.imageInfo, authMap.relationOrders]
		}
		if (task.isWholeProcess) {
			// 全流程
			items.push(authMap.pendingTrack)
		}

		// 线下调解
		if (task.isLastHalfMediate) {
			this.addMediateTab(items)
		} else {
			this.setCurrentTab(items)
		}
	}

	private addMediateTab(items: any) {
		let itemsCopy = items || cloneDeep(this.tabs.items)
		let hasMediateTab = itemsCopy.some((item: any) => {
			return item.title === '调解信息'
		})
		if (!hasMediateTab) {
			itemsCopy.unshift(authMap.mediateInfo)
			this.setCurrentTab(itemsCopy)
		}
		this.tabs.callback = (key: any) => {
			if (this.order.orderStatus === '04' && this.order.auditOperationTime) {
				return
			}
			this.tabs.index = key
		}
		// this.tabs = { ...this.tabs }
	}

	// 返回按钮
	public back() {
		this.$router.go(-1)
	}
}
